$(document).ready(function () {
    const shopDataLayer = getShopDataLayer();

    $(".loadMore__button").text(shopDataLayer.buttons.loadMore);

    const sortLabel = shopDataLayer.category.sortLabel || "";

    // Přesun řazení + trigger — idempotentní, aby šlo volat i po AJAX přerenderu
    function initListSorting() {
        const $listSorting = $(".js-listSorting");

        if (!$listSorting.length) {
            return;
        }

        // přesun do filters-wrapper jen pokud tam ještě není
        const $wrapper = $(".filters-wrapper");
        if ($wrapper.length && !$wrapper.has($listSorting).length) {
            $listSorting.appendTo($wrapper);
        }

        // trigger přidat jen jednou
        if (!$listSorting.children(".js-listSorting__trigger").length) {
            $listSorting.prepend(
                "<button type=\"button\" class=\"listSorting__trigger js-listSorting__trigger\" aria-expanded=\"false\">" + sortLabel + "</button>"
            );
        }
    }

    // Klik na trigger delegovaně → navázán jednou, přežije přerender a nedubluje se
    $(document).on("click", ".js-listSorting__trigger", function (e) {
        e.stopPropagation();
        const $listSorting = $(this).closest(".js-listSorting");
        const isOpen = $listSorting.toggleClass("listSorting--open").hasClass("listSorting--open");
        $(this).attr("aria-expanded", isOpen ? "true" : "false");
    });

    // Zavření kliknutím mimo
    $(document).on("click", function (e) {
        const $listSorting = $(".js-listSorting");
        if ($listSorting.length && !$listSorting.is(e.target) && !$listSorting.has(e.target).length) {
            $listSorting.removeClass("listSorting--open");
            $listSorting.find(".js-listSorting__trigger").attr("aria-expanded", "false");
        }
    });

    initListSorting();
    document.addEventListener("ShoptetDOMContentLoaded", initListSorting);

    // Mobilní accordion filtrů — kliknutím na h4 toggle fieldsetu
    // Setup je idempotentní (guard přes .can-toggle), aby šel volat opakovaně po AJAX přerenderu
    function initFilterAccordion() {
        if ($(window).width() > 767) {
            return;
        }

        $("#category-filter-hover .filter-section").each(function () {
            const $section = $(this);

            if ($section.hasClass("can-toggle") || !$section.children("h4").length) {
                return;
            }

            $section.addClass("can-toggle");

            // sekce se zaškrtnutým filtrem nechat otevřenou, ostatní sbalit
            if ($section.find("input:checked").length) {
                $section.addClass("active");
            } else {
                $section.children().not("h4").hide();
            }
        });
    }

    // Klik navázán delegovaně → jen jednou, přežije AJAX přerender filtrů a nedubluje se
    $(document).on("click", "#category-filter-hover .can-toggle > h4", function () {
        $(this).siblings().stop(true, true).slideToggle();
        $(this).closest(".can-toggle").toggleClass("active");
    });

    initFilterAccordion();
    document.addEventListener("ShoptetDOMContentLoaded", initFilterAccordion);
});